import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supply-and-delivery',
  templateUrl: './supply-and-delivery.component.html',
  styleUrls: ['./supply-and-delivery.component.css']
})
export class SupplyAndDeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/pages/services/supply-and-delivery/supply-and-delivery.component.ts